<template>
  <b-modal
    id="modal-lab-procedure"
    size="xl"
    modal-class="medhop-lookup-modal medhop-lab-modal"
    body-class="medhop-lookup-modal__body"
    hide-header
    hide-footer
    @show="modalOnShow"
    @hidden="modalOnHide"
  >
    <header class="medhop-lookup-modal__header">
      <span class="medhop-lookup-modal__icon"><i class="fas fa-flask"></i></span>
      <div>
        <h2>Pilih pemeriksaan laboratorium</h2>
        <p>Cari satu atau beberapa pemeriksaan untuk dimasukkan ke transaksi.</p>
      </div>
      <button type="button" class="medhop-lookup-modal__close" aria-label="Tutup" @click="$bvModal.hide('modal-lab-procedure')">
        <i class="fas fa-times"></i>
      </button>
    </header>

    <div class="lab-lookup-filter hc-no-form-icons">
      <div class="lab-lookup-filter__field">
        <label for="lab-lookup-name">Nama pemeriksaan</label>
        <div class="lab-lookup-filter__input">
          <i class="fas fa-search" aria-hidden="true"></i>
          <b-form-input
            id="lab-lookup-name"
            v-model="filter.name"
            type="search"
            placeholder="Cari nama pemeriksaan laboratorium"
            @keyup="filterByName"
            @keyup.enter="applyFilter"
          />
        </div>
      </div>
      <div class="lab-lookup-filter__summary"><i class="fas fa-database"></i>{{ totalRows }} pemeriksaan</div>
      <b-button class="lab-lookup-filter__button lab-lookup-filter__button--search" @click="applyFilter">
        <i class="fas fa-search"></i><span>Cari</span>
      </b-button>
      <b-button class="lab-lookup-filter__button lab-lookup-filter__button--reset" @click="resetFilter">
        <i class="fas fa-undo-alt"></i><span>Reset</span>
      </b-button>
    </div>

    <b-table striped hover responsive class="lab-lookup-table" :items="items" :fields="fields">
      <template #table-colgroup="scope">
        <col v-for="field in scope.fields" :key="field.key" :style="{ width: field.key === 'actions' ? '12%' : '' }" />
      </template>
      <template #cell(price)="data">
        <div class="font-weight-bolder">Rp {{ formatCurrency(data.item.price) }}</div>
      </template>
      <template #cell(doctor_commission)="data">
        <div>Rp {{ formatCurrency(data.item.doctor_commission) }}</div>
      </template>
      <template #cell(hospital_income)="data">
        <div>Rp {{ formatCurrency(data.item.hospital_income) }}</div>
      </template>
      <template #cell(actions)="data">
        <button type="button" :class="['lab-select-toggle', { 'is-selected': setChecked(data.item.id) }]" @click="chooseItem(data.item)">
          <i :class="setChecked(data.item.id) ? 'fas fa-check-circle' : 'fas fa-plus'"></i>
          <span>{{ setChecked(data.item.id) ? 'Dipilih' : 'Pilih' }}</span>
        </button>
      </template>
    </b-table>

    <b-pagination
      v-if="items.length !== 0"
      v-model="currentPage"
      class="mt-3"
      :total-rows="totalRows"
      :per-page="perPage"
      aria-controls="my-table"
      aria-label="Navigasi halaman pemeriksaan laboratorium"
      @page-click="pageOnClick"
    />
  </b-modal>
</template>

<script>
import { debouncer, getPromoAmount } from "@/core/modules/Helper.js"
import module from '@/core/modules/CrudModule.js'

export default {
  props: {
    selectedItem: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      filter: { name: '' },
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      fields: [
        { key: 'number', label: '#', sortable: true },
        { key: 'name', label: 'Nama', sortable: true },
        { key: 'price', label: 'Harga', sortable: true },
        { key: 'lab_category_name', label: 'Kategori Lab', sortable: true },
        { key: 'doctor_commission', label: 'Komisi Dokter', sortable: true },
        { key: 'hospital_income', label: 'Pendapatan Klinik', sortable: true },
        { key: 'actions', label: 'Aksi', tdClass: 'text-center align-middle' }
      ],
      items: []
    }
  },

  methods: {
    formatCurrency(value) {
      return parseInt(value || 0, 10).toLocaleString('id-ID')
    },

    applyFilter() {
      this.currentPage = 1
      this.pagination()
    },

    resetFilter() {
      this.filter.name = ''
      this.currentPage = 1
      this.pagination()
    },

    pageOnClick(evt, page) {
      evt.preventDefault()
      this.currentPage = page
      this.pagination()
    },

    async pagination() {
      const filterParams = `&name=${encodeURIComponent(this.filter.name)}`
      const response = await module.paginate('lab-procedures', `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`)
      const pagination = response.meta.pagination
      this.totalRows = pagination.total
      const rowStart = this.perPage * (this.currentPage - 1) + 1
      response.data.forEach((row, index) => {
        row.number = rowStart + index
        row.label = row.name
        row.const_price = row.price
        row.discount_percentage = 0
        row.discount_amount = 0
        row.discount_type = 0
        row.is_bundle = row.isBundle
        row.is_deposit = 0
        row.quantity = 1
        row.promo_amount = getPromoAmount(row.promo, row.const_price)
      })
      this.items = response.data
    },

    modalOnHide() {
      this.filter.name = ''
      this.currentPage = 1
      this.totalRows = 0
      this.items = []
    },

    modalOnShow() {
      this.pagination()
    },

    filterByName() {
      debouncer(() => {
        this.currentPage = 1
        this.pagination()
      }, 500)
    },

    chooseItem(value) {
      this.$emit('chooseItem', value)
    },

    setChecked(id) {
      return this.selectedItem.findIndex(item => item.id == id) >= 0
    }
  }
}
</script>
